import React from 'react';
import times from 'lodash/times';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

interface Props {
  title: string;
  isEmpty: boolean;
  columnHeaders: ColumnHeader[];
  children: React.ReactNode;
  emptyState?: React.ReactNode;
  workflowProps?: WorkflowComponentProps;
}

export const IncomeTable = ({
  title,
  isEmpty,
  columnHeaders,
  children,
  emptyState,
  workflowProps,
}: Props) => {
  if (isEmpty) {
    return (
      <HtmlTable variant={workflowProps && 'bordered'}>
        <Box p="16">
          <Text variant="cardTitle" pb="16">
            {title}
          </Text>

          {emptyState || (
            <Text fontWeight={500} color="neutral.500">
              You have not added any items.
            </Text>
          )}
        </Box>
      </HtmlTable>
    );
  }

  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          {times(columnHeaders.length).map(key => (
            <col key={key} />
          ))}

          <col style={{ width: 126 }} />
        </colgroup>

        <caption>{title}</caption>

        <thead>
          <tr>
            {columnHeaders.map(({ text, align }) => (
              <th key={text}>
                <Text variant="smallCaps" textAlign={align || 'left'}>
                  {text}
                </Text>
              </th>
            ))}

            <th aria-label={`Actions for ${title}`}>&nbsp;</th>
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </HtmlTable>
  );
};
